import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const CheckCircle: React.FC<SvgIconProps> = ({ ...props }) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 17" sx={{ fill: "none" }}>
      <circle cx="8" cy="8.5" r="8" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16.5C9.05058 16.5 10.0909 16.2931 11.0615 15.891C12.0321 15.489 12.914 14.8997 13.6569 14.1569C14.3997 13.414 14.989 12.5321 15.391 11.5615C15.7931 10.5909 16 9.55058 16 8.5C16 7.44943 15.7931 6.40914 15.391 5.43853C14.989 4.46793 14.3997 3.58601 13.6569 2.84315C12.914 2.10028 12.0321 1.511 11.0615 1.10896C10.0909 0.706926 9.05058 0.5 8 0.5C5.87827 0.5 3.84344 1.34285 2.34315 2.84315C0.842855 4.34344 0 6.37827 0 8.5C0 10.6217 0.842855 12.6566 2.34315 14.1569C3.84344 15.6571 5.87827 16.5 8 16.5ZM7.79378 11.7356L12.2382 6.40222L10.8729 5.26444L7.05067 9.85022L5.07289 7.87156L3.816 9.12844L6.48267 11.7951L7.17067 12.4831L7.79378 11.7356Z"
        fill="#EC0089"
      />
    </SvgIcon>
  );
};

export default CheckCircle;
